const newsList = [
  {
    id: 1,
    title:
      "<apnews.com> Dadachain Unveils Vision on February 20 with Whitepaper Release, Full Platform Launch on March 17",
    link: "https://apnews.com/press-release/globenewswire-mobile/gabriel-lee-columbia-916bac2b34c0ea2320c63076cd7459e8",
    content: `
        <p><strong>By Dadachain</strong><br/>
        <em>Published 8:57 AM GMT+9, February 25, 2025</em></p>
  
        <h3>NEW YORK, NY, Feb. 24, 2025 (GLOBE NEWSWIRE)</h3>
        <p>Dadachain, a blockchain platform focused on Real World Asset (RWA) tokenization, is set to release its official whitepaper on <strong>February 20</strong>, outlining its vision, technology, and roadmap. The platform is scheduled for official launch on <strong>March 17, 2025</strong>, with its first RWA issuance featuring <strong>Starnex</strong>, a South Korean defense company.</p>
  
        <h3>Bridging the Gap: Tokenization of Pre-IPO Companies</h3>
        <p>Dadachain aims to provide a tokenization framework for Pre-IPO and CSE IPO-ready private companies, offering an alternative way to access liquidity and diversify investment opportunities.</p>
  
        <ul>
          <li><strong>Potential Exposure to Growth-Stage Companies:</strong> Providing access to companies before they go public.</li>
          <li><strong>Tokenized Asset Evolution:</strong> Digital assets reflecting companies’ development toward potential IPOs on CSE or NASDAQ.</li>
          <li><strong>Expanded Market Participation:</strong> Enabling a wider range of participants to engage with private equity investments.</li>
        </ul>
  
        <h3>Strategic Support from Columbia Capital</h3>
        <p>A key partner in Dadachain’s ecosystem, <strong>Columbia Capital</strong> provides IPO consultancy services to help companies navigate the public listing process on the CSE.</p>
  
        <blockquote>
          “By integrating tokenization with expert IPO consultancy, Dadachain and Columbia Capital aim to support high-growth companies in their development,” said Gabriel Lee, CMO of Dadachain.
        </blockquote>
  
        <h3>Ondo Finance vs. Dadachain: A Different Approach to RWA</h3>
        <p>Ondo Finance tokenizes existing NASDAQ-listed stocks, offering digital access to established assets. Dadachain, in contrast, focuses on early-stage companies.</p>
  
        <blockquote>
          “Our platform is designed to support companies in their growth journey by leveraging tokenization,” said Gabriel Lee.
        </blockquote>
  
        <h3>First RWA Issuance: Starnex Takes the Lead</h3>
        <p>Dadachain’s first tokenized asset will be <strong>Starnex</strong>, a South Korean defense company.</p>
  
        <blockquote>
          “We are excited to be the first company utilizing Dadachain’s tokenization framework,” said Sangrae Park, CEO of Starnex.
        </blockquote>
  
        <h3>Future Plans: Additional RWA Issuances to Follow</h3>
        <p>Dadachain plans to announce further RWA issuances for CSE IPO-ready companies. Updates will be shared via the official website and social media channels.</p>
  
        <h3>For Media Inquiries</h3>
        <p><strong>Brand:</strong> Dadachain</p>
        <p><strong>Contact:</strong> Media team</p>
        <p><strong>Email:</strong> <a href="mailto:ask@dadachain.xyz">ask@dadachain.xyz</a></p>
        <p><strong>Website:</strong> <a href="https://www.dadachain.xyz" target="_blank">www.dadachain.xyz</a></p>
      `,
  },
  {
    id: 2,
    title: "Ondo Finance Launches New Blockchain for Tokenized Assets",
    link: "https://www.cryptotimes.io/2025/02/07/ondo-finance-launches-new-blockchain-for-tokenized-assets/",
    content: `
      <p><strong>Written By:</strong> Iyiola Adrian</p>
      <p><strong>Reviewed By:</strong> Jahnu Jagtap</p>
      <p><strong>Last updated:</strong> February 7, 2025 2:10 AM</p>
      <p><strong>Published:</strong> February 7, 2025 1:35 AM</p>

      <h3>Ondo Finance Announces the Launch of Ondo Chain</h3>
      <p>Ondo Finance announced the launch of its new Layer 1 blockchain network, <strong>Ondo Chain</strong>, today at the <strong>Ondo Summit</strong> in New York City.</p>

      <p>This blockchain network provides essential support to institutional adoption, as tokenized real-world assets (RWAs) are becoming an important trend in the finance world.</p>

      <blockquote>
        “Ondo Chain is designed to meet the highest institutional standards while remaining open for developers and innovators,” said Nathan Allman, CEO of Ondo Finance.
      </blockquote>

      <h3>A New Approach to Public and Permissioned Governance</h3>
      <p>The platform is aimed at creating a shift in public and permissioned governance approaches to allow potential partners to work with tokenized RWAs.</p>
      <p>Ondo Chain is intended to offer a solution that combines security, lower costs, and a better user experience.</p>

      <p>Additionally, the new blockchain features <strong>permissioned validators</strong> that help prevent front-running and optimize gas fees for a more seamless experience.</p>

      <h3>Bridging TradFi and DeFi</h3>
      <p>The launch of Ondo Chain is part of a larger initiative by Ondo Finance to integrate traditional finance (TradFi) systems into the decentralized finance (DeFi) space.</p>

      <p>The new network not only offers the security and compliance that institutions require but also provides flexibility to developers.</p>
    `,
  },
];

export default newsList;
